import React from "react";
import { NavLink } from "react-router-dom";
import { Home, PlusCircle, History } from "lucide-react";

const NAV_ITEMS = [
  { label: "Home",           to: "/golive",         icon: Home,       end: true },
  { label: "New Deployment", to: "/golive/new",     icon: PlusCircle, end: true },
  { label: "Run History",    to: "/golive/history", icon: History,    end: true },
];

export default function GoLiveNav() {
  return (
    <nav className="fixed top-21 left-70 right-0 z-50 flex items-center bg-slate-100 border-b border-gray-200 shadow-sm px-8">
      {NAV_ITEMS.map(({ label, to, icon: Icon, end }) => (
        <NavLink
          key={to}
          to={to}
          end={end}
          className={({ isActive }) =>
            [
              "inline-flex items-center gap-1.5 px-4 py-3.5",
              "text-sm border-b-2 -mb-px whitespace-nowrap",
              "transition-colors duration-150",
              "no-underline hover:no-underline",
              isActive
                ? "text-slate-900 font-semibold hover:text-slate-900"
                : "border-transparent text-slate-500 font-medium hover:text-slate-900",
            ].join(" ")
          }
        >
          <Icon size={15} />
          {label}
        </NavLink>
      ))}
    </nav>
  );
}
